export default __webpack_public_path__ + "static/media/Home-Outline.9ec80e94.svg";